<div class="modal-header border-0">
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<div class="modal-body">
  <h3 class="text-center mb-4">APORTAR</h3>
  <form [formGroup]="formGroup" class="row gap-0 row-gap-3 mt-3" (submit)="submit()" autocomplete="off" novalidate>
    <div class="form-group col-12">
      <label for="description">Descrição</label>
      <input type="text" class="form-control" placeholder="Nome" formControlName="description">
    </div>
    <div class="form-group col-12 col-md-8 col-lg-7">
      <label for="type">Tipo</label>
      <select class="form-select" formControlName="type">
        <option value="">Selecione...</option>
        <option *ngFor="let item of incomeTypes" [value]="item">
          {{item}}
        </option>
      </select>
      <invalid-feedback [field]="f.type"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-5">
      <label for="frequency">Repetir</label>
      <select class="form-select" formControlName="frequency">
        <option value="">Selecione...</option>
        <option *ngFor="let item of listRecurrence" [value]="item.value">
          {{item.name}}
        </option>
      </select>
      <invalid-feedback [field]="f.frequency"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-5">
      <label for="repetitions">Nº de ocorrências</label>
      <input type="number" max="999" class="form-control" formControlName="repetitions">
      <invalid-feedback [field]="f.repetitions"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-7">
      <label for="value">Valor</label>
      <input type="text" currencyMask [options]="currencyOption" class="form-control" placeholder="R$ 0,00"
        formControlName="value">
      <invalid-feedback [field]="f.value"></invalid-feedback>
    </div>
    <div class="col-12 text-center mt-3">
      <button type="button" class="btn btn-outline-dark" data-dismiss="modal"
        (click)="modalRef.hide()">CANCELAR</button>
      <button type="submit" class="btn btn-primary">APORTAR</button>
    </div>
  </form>
</div>